import SUPPORTED_BRANDS from './brands';
import SUPPORTED_ENVIRONMENT from './environments';

const isATP: boolean = import.meta.env.VITE_PORTAL === SUPPORTED_BRANDS.ATP;

export interface IConfig {
  isProduction: boolean;
  isStaging: boolean;
  isDevelopment: boolean;
  isLocal: boolean;
  currentEnvironment: SUPPORTED_ENVIRONMENT;

  currentBrand: SUPPORTED_BRANDS.ATP;
  isATP: boolean;
  isUnified: boolean;

  isODTEnabled: boolean;
  isDedicatedAdviserEnabled: boolean;

  baseURL: string[];
  rollbarApiKey: string;
  tinyMCEKey: string;

  userPilotAppId: '48gy70h5';

  swaSmartlookApiKey: string;
  atpHotjarApiKey: number;

  monthsToRestrictPaymentDateChange: 3;

  swaAtpContactSupportTell: '1-888-600-3640';
  swaAtpContactSupportEmail: 'it-notice@achieve-test-prep.com';
  atpCustomerSuccess: string;

  upComingExamSupportLink: {
    link: 'https://smarter-advising.youcanbook.me' | 'https://advisingmeeting.youcanbook.me';
    id: 'ycbmiframeatpcustomersuccessconcierge' | 'ycbmiframeatpcustomersuccessconcierge';
  };

  swaAtpSupportLink: {
    link: '' | 'https://advisingmeeting.youcanbook.me';
    id: '' | 'ycbmiframeatpcustomersuccessconcierge';
  };

  // oneOnOneScheduleURL: string;

  bridgePlan: {
    minCourseToMatchup: number;
    minMatchupAmount: number;
    maxMatchupAmount: number;
  };
}

const settings: IConfig = {
  isProduction: import.meta.env.VITE_ENVIRONMENT === SUPPORTED_ENVIRONMENT.PRODUCTION,
  isStaging: import.meta.env.VITE_ENVIRONMENT === SUPPORTED_ENVIRONMENT.STAGING,
  isDevelopment: import.meta.env.VITE_ENVIRONMENT === SUPPORTED_ENVIRONMENT.DEVELOPMENT,
  isLocal: import.meta.env.VITE_ENVIRONMENT === SUPPORTED_ENVIRONMENT.LOCAL,
  currentEnvironment: (import.meta.env.VITE_ENVIRONMENT as SUPPORTED_ENVIRONMENT) || SUPPORTED_ENVIRONMENT.DEVELOPMENT,

  currentBrand: SUPPORTED_BRANDS.ATP,
  isATP,
  isUnified: false,

  isODTEnabled: true,
  isDedicatedAdviserEnabled: true,

  baseURL: [
    import.meta.env.VITE_API_BASE_URL || '',
    import.meta.env.VITE_API_AOD_URL || '',
    import.meta.env.VITE_API_INSTRUCTOR_URL || '',
  ],
  rollbarApiKey: import.meta.env.VITE_ROLLBAR_API || '',
  tinyMCEKey: import.meta.env.VITE_TINY_MCE_KEY || '',

  userPilotAppId: '48gy70h5',

  swaSmartlookApiKey: '641f3d84ff81fb91e22c5fe464b8c1881d94802f',
  atpHotjarApiKey: 3837965,

  monthsToRestrictPaymentDateChange: 3,

  swaAtpContactSupportTell: '1-888-600-3640',
  swaAtpContactSupportEmail: 'it-notice@achieve-test-prep.com',
  atpCustomerSuccess: 'customersuccess@achieve-test-prep.com',

  upComingExamSupportLink: {
    link: 'https://advisingmeeting.youcanbook.me',
    id: 'ycbmiframeatpcustomersuccessconcierge',
  },

  swaAtpSupportLink: {
    link: 'https://advisingmeeting.youcanbook.me',
    id: 'ycbmiframeatpcustomersuccessconcierge',
  },

  // oneOnOneScheduleURL: 'https://nursing-on-demand-tutoring.youcanbook.me/?noframe=true&skipHeaderFooter=true',

  bridgePlan: {
    minCourseToMatchup: 3,
    minMatchupAmount: 300,
    maxMatchupAmount: 1000,
  },
};

export default settings;
